import { AutocompleteInput, ReferenceInput } from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const filterToQuery = (searchText) => ({ all: searchText });

const accountReceivableHistoryFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      source="start_code"
      reference="customers"
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionValue="code"
        optionText="code"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.start_code"
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="end_code"
      reference="customers"
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionValue="code"
        optionText="code"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.end_code"
      />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default accountReceivableHistoryFilterList;
